"use client";

const LAST_NATIVE_ROUTE_KEY = "sproutly:native:lastRoute";

export function routeNativePath(rawPath) {
  if (typeof window === "undefined") return false;
  const target = normalizeNativeTarget(rawPath);
  if (!target) return false;
  rememberNativeRoute(target);
  window.location.assign(target);
  return true;
}

export function normalizeNativeTarget(rawPath) {
  const value = String(rawPath || "").trim();
  if (!value) return "";

  try {
    if (value.startsWith("/")) return value;

    const url = new URL(value);
    const currentOrigin = typeof window !== "undefined" ? window.location.origin : "";
    if (url.origin === currentOrigin || isSproutlyHost(url.hostname)) {
      return `${url.pathname}${url.search}${url.hash}`;
    }

    if (isSproutlyNativeScheme(url)) {
      const hostPath = url.hostname ? `/${url.hostname}` : "";
      const target = `${hostPath}${url.pathname}${url.search}${url.hash}`;
      return normalizeInternalPath(target);
    }
  } catch {
    return "";
  }

  return "";
}

export function rememberCurrentNativeRoute() {
  if (typeof window === "undefined") return;
  const current = `${window.location.pathname || "/"}${window.location.search || ""}${window.location.hash || ""}`;
  rememberNativeRoute(current);
}

export function getRememberedNativeRoute() {
  try {
    return sessionStorage.getItem(LAST_NATIVE_ROUTE_KEY) || localStorage.getItem(LAST_NATIVE_ROUTE_KEY) || "";
  } catch {
    return "";
  }
}

export function rememberNativeRoute(path) {
  const normalized = normalizeInternalPath(path);
  if (!normalized) return;
  try {
    sessionStorage.setItem(LAST_NATIVE_ROUTE_KEY, normalized);
  } catch {}
  try {
    localStorage.setItem(LAST_NATIVE_ROUTE_KEY, normalized);
  } catch {}
}

function isSproutlyNativeScheme(url) {
  return ["sproutly", "sproutly-dev", "space.sproutly.ios.dev", "space.sproutly.ios"].includes(
    url.protocol.replace(/:$/, "")
  );
}

function isSproutlyHost(hostname = "") {
  return hostname === "sproutly.space" || hostname.endsWith(".sproutly.space");
}

function normalizeInternalPath(path) {
  const value = String(path || "").trim();
  if (!value.startsWith("/")) return "";
  if (value.startsWith("//")) return "";
  if (value === "/") return "/";
  return value.replace(/\/{2,}/g, "/");
}
